import gql from 'graphql-tag';

export const GET_ALL_COMPONENTS = gql(`
query($maxregs: Int) {
  componentQuery {
    getAll(maxregs:$maxregs){
      id
      applicationId
      parentId
      name
      description
      active
      reusable
      reusableComponentId
      reusableApplicationId
      reusableApplicationVersion
      idType    
      idSubType 
    }
    }
}
`);

export const GET_COMPONENT_BY_ID = gql(`
query($id: Int!) {
  componentQuery {
    getById(id:$id) {
      id
      applicationId
      parentId
      name
      description
      active
      reusable
      reusableComponentId
      reusableApplicationId
      reusableApplicationVersion
      idType
      idSubType
      order,
      fcr,
      ucr,
      uum,
      fum,
      iapComponentAttributes{
          id,
          name,
          idAttributeType
      }
      iapComponentEvents{
          id,
          name,
          idEventType,
          active
      }
    }
  }
}
`);

export const GET_COMPONENT_TREE_BY_ID = gql(`
query($componentId: Int!,$applicationId: Int!,$applicationVersion: Int!) {
  componentQuery {
    getTreeById(componentId:$componentId,applicationId:$applicationId,applicationVersion:$applicationVersion) {
      id
      applicationId
      applicationVersion
      parentId
      name
      description
      active
      reusable
      reusableComponentId
      reusableApplicationId
      reusableApplicationVersion
      idType      
      idSubType
      order
      fcr
      ucr
      uum
      fum
      iapComponentEvents{
        id
        name
        description
        componentId
        idEventType 
        group       
        active
        fcr
        ucr
        uum
        fum
      }
      iapComponentAttributes{
          id
          idDataType
          idAttributeType
          componentId
          idType
          idModelValueType
          valueListId
          mandatory
          name
          value
          order
      }
      iapComponentDataSources{
          componentId
          dataSourceId
          id
          name
          applicationId
          applicationVersion
          dataSource{
              idDataSourceType
              name
              ,
        iapDataSourceDataBase{
          id
          dataSourceId
          idBaseDatos
          idDataBaseType
          querySelect
          queryFrom
          queryWhere
          queryOrderBy
          queryGroupBy
          queryHaving
          fcr
          ucr
          uum
          fum
        },
        iapDataSourceServices{
          id
          dataSourceId
          idHttpMethodType
          idAuthType
          url
          fcr
          ucr
          uum
          fum         
        },
              iapDataSourceTableAliases{
                  id
                  tableAlias
                  tableName
                  shortDescription
                  idIcon
                  join
                  
              }    
          }

      }
    }
  }
}
`);



export const GET_COMPONENT_TREE_ALLOBJCETS_BY_ID = gql(`
query($componentId: Int!,$applicationId: Int!,$applicationVersion: Int!) {
  componentQuery {
    getTreeAllObjectsById(componentId:$componentId,applicationId:$applicationId,applicationVersion:$applicationVersion) {
      id
      applicationId
      applicationVersion
      parentId
      name
      description
      active
      reusable
      reusableComponentId
      reusableApplicationId
      reusableApplicationVersion
      idType  
      idSubType    
      order
      fcr
      ucr
      uum
      fum
      iapComponentEvents{
        id
        name
        description
        componentId
        idEventType
        group
        active
        fcr
        ucr
        uum
        fum
      }
      expressions{
        id
        applicationId
        applicationVersion
        idObjeto
        objetoId
        idObjetoRoot
        objetoIdRoot
        idTypeExpression
        group
        fcr
        ucr
        uum
        fum
        iapExpressionDetails{
          id
          expressionId
          variable
          expression
          expressionTranslated
          processOrder
          localizable
          fcr
          ucr
          uum
          fum
        }
      }

      workFlows{
            id
            active
            description
            fcr
            fum
            idObjeto
            name
            objetoId
            idObjetoRoot
            objetoIdRoot
            ucr
            uum
            description
            iapWorkFlowActivities{
                id
            workFlowId
            typeWorkFlowId
            name
            label
            color
            left
            top
            isInvalid
            canDelete
            fcr
            ucr
            uum
            fum
            iapWorkFlowActivityControls
            {
              id
              workFlowActivityId
              name
              value
              localizable
              group
            }
                iapWorkFlowActivityVariables{
                    id
                    workFlowActivityId
                    name
                    isInput
                    defaultValue
                    fcr
                    ucr
                    uum
                    fum
                    iapWorkFlowActivityConnectionWorkFlowActivityVariableIdInputNavigations{
                        fcr
                        fum
                        id
                        ucr
                        uum
                        workFlowActivityVariableIdInput
                        workFlowActivityVariableIdOutput
                        externalId
                    }
                    iapWorkFlowActivityConnectionWorkFlowActivityVariableIdOutputNavigations{
                        fcr
                        fum
                        id
                        ucr
                        uum
                        workFlowActivityVariableIdInput
                        workFlowActivityVariableIdOutput
                        externalId
                    }
                }              

            }
        }

      
      iapComponentAttributes{
          id
          idDataType
          idAttributeType
          componentId
          idType
          idModelValueType
          valueListId
          mandatory
          name
          value
          order
      }
      iapComponentDataSources{
          componentId
          dataSourceId
          id
          name
          ucr
          autoSave
          autoLoad
          maxRowsReturned
          applicationId
          applicationVersion
          iapComponentDataSourceFieldConfigurations{
            componentDataSourceId
            dataSourceFieldId
            filterSearch
            filterSearchOrder
            defaultFilterSearch
            defaultFilterSearchOrder
            autoUpdate
            defaultValue
            defaultValidation
            filterResult
            filterResultOrder
            mandatory
            edit
            view
            list
            add
            editMassive
            import
            sortOrder
            idSortType
            fcr
            ucr
            uum
            fum
            dataSourceField{
                  id  
                  tableName
                  field
                  tableNameAlias
                  fieldAlias
              }
            
          }
          dataSource{
              idDataSourceType
              name
              description
              ,
        iapDataSourceDataBase{
          id
          dataSourceId
          idBaseDatos
          idDataBaseType
          querySelect
          queryFrom
          queryWhere
          queryOrderBy
          queryGroupBy
          queryHaving
          fcr
          ucr
          uum
          fum
        },
        iapDataSourceServices{
          id
          dataSourceId
          idHttpMethodType
          idAuthType
          url
          fcr
          ucr
          uum
          fum         
        },
              iapDataSourceFields{

                id
                dataSourceId
                dataSourceTableAliasId
                tableName
                field
                tableNameAlias
                fieldAlias
                primaryKey                
                foreignKey
                identityColumn
                position
                defaultValue
                nullable
                encrypted
                sqlType
                length
                precision
                idDataType
                catalogTypeId
                foreignTableName
                foreignTableFieldId
                foreignTableFieldDescription
                dataSourceLookUpId
                shortDescription
                description
                fcr
                ucr
                uum
                fum
                dataSourceLookUp{
                  id
                  dataSourceId
                  idFieldLinked
                  idFieldDescription
                  tableAlias
                  maxRowsReturned
                  queryDisplay
                  queryWhere
                  queryOrder
                  addNewvaluesOnTheFly
                  additionaFieldsOnSearch
                  fieldsOnReturn
                  idControlType
                  componentId
                  iapDataSourceLookUpFieldMaps
                  {

                      id
                    dataSourceLookUpId
                    dataSourceFieldIdTarget
                    dataSourceFieldIdSource
                    isFieldLinked
                  }
                    dataSource{
                      id,
                        applicationId,
                        applicationVersion,
                        name,
                        description,
                        idDataSourceType,
                        fcr,
                        ucr,
                        uum,
                        fum,
                        iapDataSourceTableAliases{
                            id,
                            dataSourceId,
                            tableName,
                            tableAlias,
                            shortDescription
                            idIcon,
                            join
                            fcr,
                            ucr,
                            uum,
                            fum

                        },
                        iapDataSourceDataBase{
                          id
                          dataSourceId
                          idBaseDatos
                          idDataBaseType
                          querySelect
                          queryFrom
                          queryWhere
                          queryOrderBy
                          queryGroupBy
                          queryHaving
                          fcr
                          ucr
                          uum
                          fum
                        },
                        iapDataSourceServices{
                          id
                          dataSourceId
                          idHttpMethodType
                          idAuthType
                          url
                          fcr
                          ucr
                          uum
                          fum         
                        },
                        iapDataSourceFields{
                          id,
                          dataSourceId,
                          dataSourceTableAliasId
                          tableName,
                          field,
                          tableNameAlias,
                          fieldAlias,
                          primaryKey,
                          foreignKey,
                          identityColumn,
                          dataSourceTableAliasId
                          dataSourceLookUpId
                          position,
                          defaultValue,
                          nullable,
                          encrypted
                          sqlType,
                          length,
                          precision,
                          idDataType,
                          catalogTypeId,
                          foreignTableName,
                          foreignTableFieldId,
                          foreignTableFieldDescription
                          shortDescription
                          description
                          localizable
                          fcr
                          ucr
                          fum
                          uum
                        }
                    }
                }
                          
              }
              iapDataSourceTableAliases{
                  id
                  tableAlias
                  tableName
                  shortDescription
                  idIcon
                  join
              }    
          }

      }
    }
  }
}
`);



export const GET_COMPONENT_SIMPLE_TREE_BY_ID = gql(`
query($componentId: Int!,$applicationId: Int!,$applicationVersion: Int!) {
  componentQuery {
    getTreeById(componentId:$componentId,applicationId:$applicationId,applicationVersion:$applicationVersion) {
      id
      applicationId
      applicationVersion
      parentId
      name
      description
      active
      reusable
      reusableComponentId
      reusableApplicationId
      reusableApplicationVersion
      idType   
      idSubType   
      order
      fcr
      ucr
      uum
      fum     
      iapComponentAttributes{
          id
          idDataType
          idType
          idModelValueType
          name
          value
          order
      },
      iapComponentDataSources{
          componentId
          dataSourceId
          id
          name
          applicationId
          applicationVersion
      }
      }
    }
  }
`);



export const GET_PARENTS = gql(`
query($applicationId: Int!,$applicationVersion: Int!) {
  componentQuery {
    getParents(applicationId:$applicationId,applicationVersion:$applicationVersion) {
      id
      applicationId
      applicationVersion
      parentId
      name
      description
      active
      reusable
      reusableComponentId
      reusableApplicationId
      reusableApplicationVersion
      idType   
      idSubType   
      order
      fcr
      ucr
      uum
      fum        
    }
  }
}
`);